import React from 'react';
import { FormattedMessage } from 'react-intl';
import { signaling } from '@lifesize/clients.sdk';
import { makeStyles, Theme, Box } from '@material-ui/core';
import { colors } from '@lifesize/ux-assets';

interface props {
  participant: any;
}

const WaitingRoomParticipant = ({ participant }: props) => {
  const classes = useStyles({});
  const { dialString, name } = participant;

  const allowWaitingRoomParticipant = (participant) => {
    signaling.acceptWaitingRoomParticipant(participant?.participantId);
  };
  const denyWaitingRoomParticipant = (participant) => {
    signaling.ejectWaitingRoomParticipant(participant?.participantId);
  };

  return (
    <Box data-testid="waiting-room-participant-item" className={classes.participant}>
      <Box data-testid="waiting-room-participant-name" className={classes.name}>
        {name || dialString}
      </Box>
      <Box className={classes.buttons}>
        <a
          className={classes.deny}
          data-testid="deny-waiting-room-participant"
          onClick={() => denyWaitingRoomParticipant(participant)}
        >
          <FormattedMessage id="components.inCall.waitingRoom.deny" defaultMessage="deny" />
        </a>
        <a
          className={classes.allow}
          data-testid="allow-waiting-room-participant"
          onClick={() => allowWaitingRoomParticipant(participant)}
        >
          <FormattedMessage id="components.inCall.waitingRoom.allow" defaultMessage="allow" />
        </a>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  participant: {
    alignItems: 'center',
    display: 'flex',
    fontSize: '1.2em',
    marginTop: theme.spacing(1),
    padding: `0 ${theme.spacing(3)}px`
  },
  name: {
    flex: '1 1 auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  buttons: {
    flex: '0 0 auto',
    '& a': {
      cursor: 'pointer',
      marginLeft: theme.spacing(2)
    }
  },
  allow: {
    color: colors.squadronBlue
  },
  deny: {
    color: colors.alertRed
  }
}));

export default WaitingRoomParticipant;
